module.exports = __webpack_public_path__ + "img/ai_boot_bg_img.bfc3c3df.jpg";